import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { getDataTable, getHeaders, getIds } from '../../../helper'
import { postLiquidityAndSolvencyAndCoverAge } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryAnalysis/insurance/liquiditySolvencyCoverage',
  initialState: {
    activeRowGroupId: undefined,
    headers: [],
    isLoading: true,
    ids: [],
    data: {},
    years: [],
  },
  reducers: {
    changeActiveRow: (state, { payload }) => {
      state.activeRowGroupId = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postLiquidityAndSolvencyAndCoverAge.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(
      postLiquidityAndSolvencyAndCoverAge.fulfilled,
      (state, { payload = {} }) => {
        state.isLoading = false
        const { data = [], defaultVsicId } = payload
        const ids = getIds(data)

        if (ids.length) {
          state.headers = getHeaders(data)
          state.ids = ids
          state.data = getDataTable(data, ids, defaultVsicId)
          state.activeRowGroupId = ids[0]
          const { values = [] } = data[0]
          state.years = values.map((item) => item.realYear)
        }
      },
    )
    builder.addCase(
      postLiquidityAndSolvencyAndCoverAge.rejected,
      (state, { payload }) => {
        state.isLoading = payload.isLoading
      },
    )
  },
})

export const selectIds = (state) => state[slice.name].ids
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectCellData = (rowId, index, colId) => (state) =>
  state[slice.name].data[rowId][index][colId]
export const selectActiveRowGroupId = (state) =>
  state[slice.name].activeRowGroupId
export const selectData = (state) => state[slice.name].data
export const selectHeaders = (state) => state[slice.name].headers
export const selectRowGroup = (rowGroupId) => (state) =>
  state[slice.name].data[rowGroupId]
export const selectYears = (state) => state[slice.name].years

export const { changeActiveRow } = slice.actions

register(slice.name, slice.reducer)
